import * as React from 'react';
import TextInput from '../text-input';

import { Range as Props } from './form-content.range.types';

const Range: React.FC<React.PropsWithChildren<Props>> = ({ max, min }) => {
  return (
    <div className="form-content__range">
      <div className="form-content__range-input">
        <TextInput {...min} type="number" />
      </div>
      <div className="form-content__range-line"></div>
      <div className="form-content__range-input">
        <TextInput {...max} type="number" />
      </div>
    </div>
  );
};

export default Range;
